import React from 'react';
import { useTheme } from '../../theme/theme';
import { Tooltip } from "@material-tailwind/react";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Tooltip className="text-xs bg-primary rounded-md py-1 px-2 z-[100]"
      content={theme === 'dark' ? "Switch to Light Mode" : "Switch to Dark Mode"}
      placement="top"
    >
      <button
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        aria-pressed={theme === 'dark'}
        aria-label="theme toggle"
        className="p-2 rounded-md focus:outline-none text-slate-800 dark:text-yellow-400"
      >
        {theme === 'dark' ? (
          // آیکون خورشید
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="5" />
            <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
          </svg>
        ) : (
          // آیکون ماه
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
          </svg>
        )}
      </button>
    </Tooltip>
  );
}
